import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getBiomethaneReport } from '../../reducers/reportGoReducer';
import { Form } from 'react-final-form';
import { FormActions } from '../../components';
import { goReportFields } from '../../constants/GoReport.js';
import { FORM_GO_REPORT_BIOMETHANE } from '../../constants/formKeys';
import { Button, Spin, Table, Modal } from 'antd';
import { getRole } from '../../reducers/userReducer';
import { isAdmin } from '../../utils/roles';
import * as actions from '../../actions/actionCreators/reportGoActionCreators';
import { withRouter } from 'react-router-dom';
import {
  formValueSelector,
  updateFormState,
} from '../../reducers/reactFinalFormReducer';
import FormStateToRedux from '../FormStateToRedux';

import BaseGoReport, { calcInitialDates } from './BaseGoReport';

export class BiomethaneGoReport extends BaseGoReport(Component) {
  static propTypes = {
    t: PropTypes.func.isRequired,
    isUserAdmin: PropTypes.bool.isRequired,
    formValues: PropTypes.object,
    fetchReportGoItemsPage: PropTypes.func.isRequired,
    resetGoBiomethaneReport: PropTypes.func.isRequired,
    goReport: PropTypes.object,
    location: PropTypes.object,
    initialValues: PropTypes.object,
    updateFormState: PropTypes.func.isRequired,
  };

  formRef = null;

  handleClear = () => {
    if (this.formRef) {
      this.formRef.restart(this.props.initialValues);
      this.props.updateFormState(FORM_GO_REPORT_BIOMETHANE, {
        values: this.props.initialValues,
      });
    }
  };

  render() {
    const { t, goReport, location, initialValues } = this.props;
    const { data, page, totalElements, pageSize } = goReport.toJSON();
    const { monthFilter } = this.state;

    return (
      <div>
        <Spin spinning={this.state.loading}>
          <Form
            initialValues={initialValues}
            onSubmit={() => {}}
            render={({ form }) => {
              this.formRef = form;
              return (
                <form>
                  <FormStateToRedux form={FORM_GO_REPORT_BIOMETHANE} />
                  {this.renderFirstRows(monthFilter, t)}
                  <Table
                    scroll={{ x: 'auto' }}
                    rowKey={goReportFields.ID}
                    columns={this.getBiomethaneReportColumns(t)}
                    dataSource={data}
                    bordered
                    pagination={{
                      onChange: this.onPageChange,
                      current: page,
                      total: totalElements,
                      pageSize,
                      defaultCurrent: 1,
                    }}
                  />
                  <FormActions>
                    {this.createAndClearButtons(t, location)}
                    <a
                      href={this.getBiomethaneGenerateXlsUrl()}
                      rel="noopener noreferrer"
                    >
                      <Button>{t('goReport.generateXls')}</Button>
                    </a>
                  </FormActions>
                </form>
              );
            }}
          />
        </Spin>
        <Modal
          title={t('goReport.reportDetailModalTitle')}
          open={this.state.detailModalVisible}
          footer={false}
          width="1200px"
          onCancel={this.hideDetailModal}
        >
          {this.renderBiomethaneGoReportDetails()}
        </Modal>
      </div>
    );
  }

  componentWillUnmount() {
    this.props.resetGoBiomethaneReport();
  }
}

const selector = formValueSelector(FORM_GO_REPORT_BIOMETHANE);

const mapStateToProps = (state) => ({
  isUserAdmin: isAdmin(getRole(state)),
  initialValues: calcInitialDates(),
  formValues: selector(state),
  goReport: getBiomethaneReport(state),
});

const mapDispatchToProps = {
  fetchReportGoItemsPage: actions.fetchBiomethaneReportGoItemsPage,
  resetGoBiomethaneReport: actions.goBiomethaneReportResetMasterActionCreator,
  updateFormState,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(BiomethaneGoReport));
